import { useQuery } from '@apollo/client';
import { useNotifications } from '@risksmart-app/components/src/notifications/useNotifications';
import type { Attestation_Record_Bool_Exp } from '@risksmart-app/web-graphql-client/generated/graphql';
import {
  GetPolicyAttestationRecordsDocument,
  Parent_Type_Enum,
} from '@risksmart-app/web-graphql-client/generated/graphql';

import useEntityWhereFilter from '@/hooks/useEntityWhereFilter';
import { useIsFeatureVisibleToOrg } from '@/utils/featureFlags';

import { useGetAttestationsRegister as useGetAttestationsRegisterTRPC } from './useGetAttestationsRegisterTRPC';
export const useGetAttestationsRegister = (userId?: string, skip?: boolean) => {
  const trpcEnabled = useIsFeatureVisibleToOrg('trpc');
  const { addNotification } = useNotifications();

  const whereFilter = useEntityWhereFilter<Attestation_Record_Bool_Exp>(
    Parent_Type_Enum.AttestationRecord
  );
  const userWhere: Attestation_Record_Bool_Exp = {
    UserId: { _eq: userId },
  };

  const {
    data: graphqlData,
    loading: graphqlLoading,
    refetch: graphqlRefetch,
  } = useQuery(GetPolicyAttestationRecordsDocument, {
    variables: {
      where: userId ? userWhere : whereFilter,
    },
    fetchPolicy: 'no-cache',
    skip: trpcEnabled || skip, // Skip GraphQL query when TRPC is enabled
    onError: (error) => {
      if (!trpcEnabled) {
        addNotification({
          type: 'error',
          content: <>{error.message}</>,
        });
      }
    },
  });

  const {
    data: trpcData,
    loading: trpcLoading,
    refetch: trpcRefetch,
  } = useGetAttestationsRegisterTRPC(userId, skip);

  // Return appropriate data based on feature flag
  if (trpcEnabled) {
    return {
      loading: trpcLoading,
      data: trpcData,
      refetch: () => trpcRefetch(),
    };
  }

  return {
    loading: graphqlLoading,
    data: graphqlData,
    refetch: () => graphqlRefetch(),
  };
};
